import React, { useEffect, useState } from "react";
import { object, string } from "prop-types";
import { Link } from "@quintype/components";
import get from "lodash/get";

import Contributor from "../../atoms/Contributor";
import ContributorImage from "../../atoms/ContributorImage";
import CardImage from "../../atoms/CardImage";
import Headline from "../../atoms/Headline";

import { getAuthorName } from "../../utils/utils";
import { getAuthorObj } from "../../helper/api";

import "./opinionStoryCard.m.css";

const OpinionStoryCard = ({ story, headline, subheadline, storySlug, publisherLang }) => {
  const authorObj = story.authors[0];
  const { slug, id } = authorObj;
  const authorName = getAuthorName(story);
  const authorDisplayName = get(story, ["metadata", "story-attributes", "author-display-name", "0"], null);
  const hideAuthorName = get(story, ["metadata", "story-attributes", "hideauthor", 0], "no");
  const authorLocation = get(story, ["metadata", "author-location"], "").trim();
  const headlineStyle = `${publisherLang}-story-headline`;
  const subHeadlineStyle = `${publisherLang}-sub-headline`;

  const [firstauthorObj, setFirstAuthorObj] = useState({});

  const fetchAuthorObj = async (authorId) => {
    if (authorId) {
      const data = await getAuthorObj(authorId);
      setFirstAuthorObj(data);
    }
  };
  useEffect(() => {
    fetchAuthorObj(id);
  }, []);
  return (
    <div styleName="base" className="opinion-story-card">
      {hideAuthorName !== "no" ? (
        <CardImage story={story} showAlternateImage={true} widths={[100]} aspectRatio={[3, 2]} imageType="image3x2" />
      ) : authorDisplayName ? (
        <ContributorImage authorObj={firstauthorObj} authorDisplayName={authorDisplayName} />
      ) : (
        <ContributorImage authorObj={firstauthorObj} slug={`author/${slug}`} authorDisplayName={authorDisplayName} />
      )}
      <div styleName="story-details" className="story-details">
        {subheadline ? (
          <Link href={story.slug}>
            <Headline text={subheadline} headerLevel={3} className="section-name" styleName={subHeadlineStyle} />
          </Link>
        ) : null}
        <Link href={storySlug}>
          <Headline text={headline} headlineType={30} headerLevel={3} styleName={headlineStyle} />
        </Link>
        {hideAuthorName === "no" && (
          <Contributor
            name={authorName}
            authorObj={firstauthorObj}
            contributorType={2}
            slug={`author/${slug}`}
            authorDisplayName={authorDisplayName}
            showBio={true}
            authorLocation={authorLocation}
          />
        )}
      </div>
    </div>
  );
};

OpinionStoryCard.propTypes = {
  story: object.isRequired,
  headline: string,
  subheadline: string,
  storySlug: string,
  publisherLang: string,
};

export default OpinionStoryCard;
